import React from "react";

const Map = () => {
  return (
    <div>
      <iframe
        title="Shri Ram Finance Corporation Pvt. Ltd." // Add a unique title property
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.3481940470183!2d81.66508707597383!3d21.257680479875297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dd67dcf7c807%3A0xfc17c2440b39bd60!2sShri%20Ram%20Finance%20Corporation%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1741256043950!5m2!1sen!2sin"
        width="100%" // Set the width to 100%
        height="500px" // Set the height to 500px
        style={{ border: "0", borderRadius: "30px" }} // Use an object for the style prop
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;
